import loggingService from '../util/loggingService'

var serviceName = 'themeService'
var path = '/ThemeInstance/'
var isDebug = false

function put (http, themeInstance) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, themeInstance)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?themeInstanceId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search by ' + searchObject.ProjectId)
    return http.post(path + 'Search', searchObject)
}

function getThemeList () {
    return [
        {themeId: 1, description: 'Agriculture'},
        {themeId: 2, description: 'Architecture'},
        {themeId: 3, description: 'Archaeology - Prehistoric'},
        {themeId: 4, description: 'Archaeology - Historic - Aboriginal'},
        {themeId: 5, description: 'Archaeology - Historic - Non-Aboriginal'},
        {themeId: 6, description: 'Art'},
        {themeId: 7, description: 'Commerce'},
        {themeId: 8, description: 'Communications'},
        {themeId: 9, description: 'Community Planning and Development'},
        {themeId: 10, description: 'Conservation'},
        {themeId: 11, description: 'Economics'},
        {themeId: 12, description: 'Education'},
        {themeId: 13, description: 'Engineering'},
        {themeId: 14, description: 'Entertainment/Recreation'},
        {themeId: 15, description: 'Ethnic Heritage - Asian'},
        {themeId: 16, description: 'Ethnic Heritage - Black'},
        {themeId: 17, description: 'Ethnic Heritage - European'},
        {themeId: 18, description: 'Ethnic Heritage - Hispanic'},
        {themeId: 19, description: 'Ethnic Heritage - Native American'},
        {themeId: 20, description: 'Ethnic Heritage - Pacific Islander'},
        {themeId: 21, description: 'Ethnic Heritage - Other'},
        {themeId: 22, description: 'Exploration/Settlement'},
        {themeId: 23, description: 'Health/Medicine'},
        {themeId: 24, description: 'Industry'},
        {themeId: 25, description: 'Invention'},
        {themeId: 26, description: 'Landscape Architecture'},
        {themeId: 27, description: 'Law'},
        {themeId: 28, description: 'Literature'},
        {themeId: 29, description: 'Maritime History'},
        {themeId: 30, description: 'Military'},
        {themeId: 31, description: 'Performing Arts'},
        {themeId: 32, description: 'Philosophy'},
        {themeId: 33, description: 'Politics/Government'},
        {themeId: 34, description: 'Religion'},
        {themeId: 35, description: 'Science'},
        {themeId: 36, description: 'Social History'},
        {themeId: 37, description: 'Transportation'},
        {themeId: 38, description: 'Other'}
    ]
}

export default {
    put: put,
    get: get,
    search: search,
    getThemeList: getThemeList
}



// WEBPACK FOOTER //
// ./src/services/siteForm/ThemeService.js